<template>
  <div class="table">
    <date-t-head :value="value" />
    <date-t-body :value="value" :selectedValue="selectedValue" />
  </div>
</template>
<script>
import DateTBody from "@/components/VCalendar/DateTBody.vue";
import DateTHead from "@/components/VCalendar/DateTHead.vue";
import { dayjs } from "@/utils/helpers";
export default {
  name: "DateTable",
  components: { DateTBody, DateTHead },
  props: {
    value: {
      type: Object,
      default: () => dayjs()
    },
    selectedValue: [Object, Array]
  }
};
</script>
